<template lang="pug">
.page
  SspNav(
    :title="areaData.title"
    :pages="areaData.menuItems"
    :homeLink="areaData.homeLink"
    :navColorClass="areaData.navColorClass")
  main
    Breadcrumb
    .header-area(v-if="title")
      .title
        i(v-if="icon" :class="icon")
        i(v-else).fa.fa-slack
        span.ml5 {{title}}
      .actions
        slot(name="actions")
    .body-area
      slot
  slot(name="footer")
    .footer Copyright ©
      a.ml5(href="http://www.kezzler.com") Kezzler AS
      router-link.ml5(:to="{ name: 'about' }") | About
</template>

<script>
import Mustache from 'mustache'
import menuItemsCore from '@/data/menu-items/core'
import menuItemsTnt from '@/data/menu-items/track-trace'
import Breadcrumb from '../nav/Breadcrumb'
import SspNav from '../nav/SspNav'


const areas = {
  core: {
    title: 'Core',
    homeLink: '#/core',
    menuItems: menuItemsCore,
    navColorClass: 'nav-color4'
  },
  activator: {
    title: 'Activate',
    homeLink: '#/activator',
    menuItems: [],
    navColorClass: 'nav-color1'
  },
  tnt: {
    title: 'Track&Trace',
    homeLink: '#/trackntrace',
    menuItems: menuItemsTnt,
    navColorClass: 'nav-color2'
  }
}
export default {
  props: {
    area: String, // core, activator, tnt
    default: areas.core
  },
  components: {
    Breadcrumb,
    SspNav
  },
  computed: {
    icon() {
      const { meta } = this.$route
      return meta.icon && Mustache.render(meta.icon, this.$route)
    },
    title() {
      const { meta } = this.$route
      return meta && meta.title && Mustache.render(meta.title, this.$route)
    },
    areaData() {
      return areas[this.area] || {
        title: `invalid area ${this.area}`
      }
    }
  }
}
</script>
<style lang="scss">
.header-area {
  display: flex;
  padding-bottom: 5px;
  margin-bottom: 5px;
  margin-top: -20px;
  .title {
    flex: 1;
    font-size: 22px;
  }
  .actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    .spacer {
      width: 5px;
      height: 5px;
    }
    label {
      margin: 0;
    }
  }
}
.body-area {
  margin-bottom: 30px;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 20px;
  background-color: #f5f5f5;
  padding-top: 2px;
  font-size: 11px;
  text-align: center;
  margin-top: 20px;
  border-top: solid #ddd 1px;
}

.footer a {
  color: #111;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/SspLayout.vue